

export const htmlParser = (text) =>{
    const doc = new DOMParser().parseFromString(
        text,
        'text/html',
    );
    const textContent = doc.body.textContent || '';
    return textContent;
}